import React from 'react';
const ArrowRight = (props) => {
    const strokeColor = props.stroke || '#3C3F47';
    const strokeOpacity = props.opcacity || 1;
    const attribute = Object.assign({}, props);
    delete attribute.stroke;
    delete attribute.opcacity;
    return (React.createElement("svg", Object.assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("path", { d: "M10.5 13L5.5 8L10.5 3", stroke: strokeColor, strokeOpacity: strokeOpacity, "stroke-linejoin": "round" })));
};
export default ArrowRight;
